export enum ControlerEnum {
  Vehicle = 'vehicle',
  Metadata = 'metadata',
  Offer = 'offer',
  User = 'user',
  Calculation = 'calculation',
  Country = 'country',
  Vendor = 'vendor',
  Pricelist = 'pricelist',
  Vendorcountry = 'vendorCountry',
  VendorUser = 'vendorUser',
  Usercountry = 'userCountry',
  businessSubject = 'businessSubject',
  CarTypes = 'metadata/carTypes',
  CarSegmants = 'metadata/carSegments',
  MtAndRv = 'mtAndRv',
  Tires = 'tires',
  TiresMetadata = 'tires/metadata',
  InterestRate = 'interestRate'
}
